var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.videoCallData && _vm.userData)?_c('VideoCallRoom',{attrs:{"videoCallData":_vm.videoCallData,"userData":_vm.userData,"atencionID":_vm.videoCallData.attention_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }